import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EmailSignupBuilder } from './email-signup.builder';
import {
  ITrackingAction,
  ITrackingObject,
  ITrackingProperties,
} from 'i2g-ng-tracking';
import { IconSizesEnum, IIcon, IFormFieldErrorMessages } from 'i2g-ng-ui';

export interface IEmailSignupInfo {
  email: string;
  password: string;
}

@Component({
  selector: 'app-email-signup',
  templateUrl: './email-signup.component.html',
  styleUrls: ['./email-signup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [EmailSignupBuilder],
})
export class EmailSignupComponent implements OnInit, OnChanges {
  @Input() disabled = false;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;
  @Input() trackingAdditionalProperties: ITrackingProperties;
  @Input() processing: boolean;
  @Input() showLegalNote: boolean;
  @Input() legalNote: string;

  @Output() buttonSubmit = new EventEmitter<IEmailSignupInfo>();

  formKeys: any;
  form: FormGroup;
  passwordErrorMessage: IFormFieldErrorMessages;
  spinnerIcon: IIcon;

  constructor(private _emailSignupBuilder: EmailSignupBuilder) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled && this.form) {
      if (this.disabled) {
        this.form.disable();
      } else {
        this.form.enable();
      }
    }
  }

  ngOnInit() {
    this.formKeys = this._emailSignupBuilder.FORM_KEYS;
    this.form = this._emailSignupBuilder.buildForm();
    this.passwordErrorMessage = this._emailSignupBuilder.buildPasswordMinLengthErrorMessages();
    this.spinnerIcon = {
      name: 'dotted-spinner',
      size: IconSizesEnum.custom,
    };
  }

  get emailAddress() {
    return this.form.get(this.formKeys.EMAIL_ADDRESS);
  }

  get password() {
    return this.form.get(this.formKeys.PASSWORD);
  }

  submit() {
    if (this.form.invalid) {
      this.emailAddress.markAsDirty();
      this.password.markAsDirty();
      return;
    }

    const email = this.emailAddress.value;
    const password = this.password.value;
    this.buttonSubmit.emit({ email, password });
  }
}
